// Styles for swiper root shadow
// Changes in styles and indents for shadow root should be made according to the type attribute
const INJECT_STYLES = `   
    :host .swiper-wrapper {
        margin: 20px 0;
    }
    :host .swiper-selectBidDropdown-initialized .swiper-wrapper {
        height: 320px;
        flex-direction: column;
        margin: 0;
        touch-action: pan-x;
    }
    :host .swiper-grid .swiper-wrapper {
        gap: 25px 0;
    }
    :host .swiper-lotGalleryMain-initialized .swiper-wrapper,
    :host .swiper-galleryPopupNavigation-initialized .swiper-wrapper,
    :host .swiper-mainLotGallery-initialized .swiper-wrapper,
    :host .swiper-cardPopup-initialized  .swiper-wrapper,
    :host .swiper-lotGallery-initialized .swiper-wrapper,
    :host .swiper-mainLotGalleryBullets-initialized .swiper-wrapper {
        margin: 0;
    }
    :host .swiper-lotsLiveCatalog-initialized .swiper-wrapper,
    :host .swiper-lotsLivePopupCatalog-initialized .swiper-wrapper {
        margin: 20px 15px;
    }
    :host .swiper-lotsTrending-initialized .swiper-wrapper {
        margin: 100px 15px;
    }
    :host .swiper-lotGallery-vertical .swiper-wrapper {
        flex-direction: column;
    }

    @media all and (max-width: 1280px) {
        :host .swiper-lotsTrending-initialized .swiper-wrapper {
            margin: 50px 15px 70px;
        }
    }
     @media all and (max-width: 480px) {
        :host .swiper-lotsTrending-initialized .swiper-wrapper {
            margin: 25px 15px 5px;
        }
    }
`;

// Breakpoints for swiper type
const BREAKPOINTS = {
  default: {},
  lots: {
    320: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    360: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4
    },
    1440: {
      slidesPerView: 6,
      slidesPerGroup: 6
    }
  },
  auctionResults: {
    320: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 23
    },
    1440: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 46
    }
  },
  lotsTrending: {
    320: {
      centeredSlides: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        dynamicMainBullets: 1
      }
    },
    620: {
      centeredSlides: false,
      spaceBetween: 0,
      slidesPerView: 2
    },
    768: {
      spaceBetween: 0,
      centeredSlides: false,
      slidesPerView: 3
    },
    1024: {
      centeredSlides: true,
      slidesPerView: 3
    },
    1280: {},
    1440: {
      spaceBetween: 35
    }
  },
  lotGalleryMain: {
    320: {
      spaceBetween: 10,
      slidesPerView: 1,
      allowTouchMove: true
    },
    1024: {
      spaceBetween: 20,
      allowTouchMove: false
    }
  },
  lotGallery: {
    320: {
      spaceBetween: 10,
      direction: "horizontal",
      slidesPerGroup: 4,
      slidesPerView: 4,
      allowTouchMove: true
    },
    545: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      spaceBetween: 10,
      direction: "vertical"
    },
    1024: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      spaceBetween: 10
    }
  },
  lotsLiveCatalog: {
    320: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 5
    },
    1600: {
      slidesPerView: 7
    }
  },
  lotsLiveCatalogSeller: {
    320: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 5
    },
    1024: {
      slidesPerView: 7
    },
    1600: {
      slidesPerView: 9
    }
  },
  lotsLivePopupCatalog: {
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      grid: {
        rows: 2
      }
    },
    425: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      grid: {
        rows: 2
      }
    },
    580: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      grid: {
        rows: 2
      }
    },
    780: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      grid: {
        rows: 2
      }
    },
    1024: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      grid: {
        rows: 2
      }
    }
  },
  selectBidDropdown: {
    320: {
      slidesPerGroup: 8,
      slidesPerView: 8,
      allowTouchMove: true,
      scrollbar: { dragSize: 30 }
    }
  }
} as Record<string, any>;

export { BREAKPOINTS, INJECT_STYLES };
